// extracted by mini-css-extract-plugin
export default {"shareButtons":"ShareTile_shareButtons__ThLfZ","shareButton":"ShareTile_shareButton__xRoCY"};